import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class RouteStatusDisplayListComponent implements IController {
  statuses: any;
  isRow: any;
  onChange: Function;

  constructor() {
  }

  onRemove(status) {
    this.onChange({statuses: _.filter(this.statuses, (i) => {return i !== status})});
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routeStatusDisplayList', {
    bindings: {
      statuses: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./route-status-display-list.html').default,
    controller: RouteStatusDisplayListComponent
  });
